import classNames from 'classnames';

import type { PolymorphicComponent } from '@hh.ru/magritte-types';
import type { BaseTextProps } from '@hh.ru/magritte-ui-typography/types';

import styles from './base-text.less';

export const BaseText: PolymorphicComponent<React.PropsWithChildren<BaseTextProps>, 'div'> = ({
    Element = 'div',
    style,
    typography,
    children,
    maxLines,
    ...props
}) => {
    const textStyles = classNames(
        styles.text,
        maxLines && styles.textMaxLines,
        styles[`text_style-${style}`],
        styles[`text_typography-${typography}`]
    );
    return (
        <Element {...props} className={textStyles} style={{ WebkitLineClamp: maxLines }}>
            {children}
        </Element>
    );
};
